import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    return {
        selectedPayment: state?.components?.basket?.data?.selected_payment ?? null,
    }
}

const mapDispatchToProps = {}

const hocOrderStepsHeader = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocOrderStepsHeader
